import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import SocialMediaLinks from "../../components/social-links"
import Logo from "../../components/logo"
import Navigation from "./navigation/navigation"
import { FaPhone } from "react-icons/fa"
import Headroom from "react-headroom"
import AlertBanner from "./alert-banner"

import headerStyles from "../../styles/global.module.scss"

const Header = ({ metadata }) => {
  return (
    <Headroom>
      <AlertBanner metadata={metadata} />
      <div className={headerStyles.topBar}>
        <div className={headerStyles.container}>
          <div className={headerStyles.sub}>
            <span>
              <FaPhone />{" "}
              <a
                href={`tel:${metadata.CompanyPhone}`}
                title={metadata.CompanyPhone}
              >
                {metadata.CompanyPhone}
              </a>
            </span>
          </div>
          <div className={headerStyles.sub}>
            <SocialMediaLinks />
          </div>
          <div className={headerStyles.sub}>
            <Link className={headerStyles.link} to="/faq/">
              FAQS
            </Link>
          </div>
        </div>
      </div>
      <header className={headerStyles.header}>
        <div
          className={`${headerStyles.container} ${headerStyles.flexWrapper}`}
        >
          <div className={headerStyles.logo}>
            <Link
              aria-label={metadata.CompanyName}
              alt={metadata.CompanyName}
              to="/"
            >
              <Logo />
            </Link>
          </div>
          <Navigation />
        </div>
      </header>
    </Headroom>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
